<div class="row m-2">
    <div class="col-md-6">
        <form [formGroup]="primaryForm" (ngSubmit)="update()" *ngIf="sheduledId > 0 else notReference">
            <div class="card">
                <div class="card-header text-center" style="text-transform: uppercase;">GESTIÓN DE RONDA</div>
                <div class="card-body">
                    <div class="mb-3">
                        <label class="form-label" for="facility_id">Instalación</label>
                        <select class="form-select" formControlName="facility_id">
                            <option value="0">SELECCIONAR</option>
                            <option *ngFor="let item of facilities" [value]="item.id">{{ item.name | uppercase }}
                            </option>
                        </select>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label class="form-label" for="rounds_type_id">Tipo de ronda</label>
                            <select class="form-select" formControlName="rounds_type_id">
                                <option value="0">SELECCIONAR</option>
                                <option *ngFor="let type of types" [value]="type.id">{{ type?.tag | uppercase }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label" for="rounds_type_id">Correo de notificación</label>
                            <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa-regular fa-envelope"></i>
                                </span>
                                <input class="form-control" type="email" formControlName="email_notification">
                            </div>
                        </div>
                    </div>

                    <div class="row gx-3 mb-3">
                        <div class="col-md-6">
                            <label class="form-label" for="start_date">Fecha y Hora de inicio</label>
                            <input type="datetime-local" class="form-control" formControlName="start_date">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label" for="end_date">Fecha y Hora de fin</label>
                            <input type="datetime-local" class="form-control" formControlName="end_date">
                        </div>
                    </div>
                    <br>
                    <div class="col-md-12">
                        <label class="form-label" for="end_date">Mapa instalación</label><br>
                        <div class="image-container">
                            <img class="mb-2 zoomable-image" style="cursor: pointer; width:100%"
                                [src]="facility?.image_path" (error)="handleImageError()" />
                        </div>
                    </div>

                    <button class="btn btn-primary w-100" type="submit">GUARDAR CAMBIOS</button>
                </div>
            </div>
        </form>
        <ng-template #notReference>
            <div class="alert alert-warning mt-3">
                <h6 class="alert-heading">No existe referencia</h6>
            </div>
        </ng-template>
    </div>
    <div class="col-md-6">
        <app-drop-tags [tagsAvailable]="tagsAvailable" [tagsSelected]="tagsSelected"
            (onTagSelected)="tagsSelected=$event" />
    </div>
</div>